import NetworkService from './network.service';
import ClientService from './client.service';
import AuthService from './auth.service';
import SpinnerService from './spinner.service';

// Adding all services to an angular module and exporting them
let servicesModule = angular.module('services', [])
.service('NetworkService', NetworkService)
.service('ClientService', ClientService)
.service('AuthService', AuthService)
.service('SpinnerService', SpinnerService)
.name;

export default servicesModule;



// WEBPACK FOOTER //
// ./client/app/_services/services.js